/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vp_Blocked_Override_HintInputs */



/**
* | output |
* | --- |
* | "If the scores are right (e.g. Life Boon), record a judge override." |
*
* @param {Vp_Blocked_Override_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vp_blocked_override_hint = /** @type {((inputs?: Vp_Blocked_Override_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vp_Blocked_Override_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si les scores sont justes (ex. Life Boon), enregistrez une décision de juge.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Si los resultados son correctos (p. ej. Life Boon), registre una decisión del juez.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Se os resultados estão certos (ex. Life Boon), registre uma decisão de juiz.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Se i punteggi sono giusti (es. Life Boon), registra una decisione del giudice.")
	return /** @type {LocalizedString} */ ("If the scores are right (e.g. Life Boon), record a judge override.")
});